import { render, staticRenderFns } from "./OperatorPlatformService.vue?vue&type=template&id=ea22f278&scoped=true"
import script from "./OperatorPlatformService.vue?vue&type=script&lang=ts"
export * from "./OperatorPlatformService.vue?vue&type=script&lang=ts"
import style0 from "./OperatorPlatformService.vue?vue&type=style&index=0&id=ea22f278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea22f278",
  null
  
)

export default component.exports